package app.bloomey.web.pages.admin

import androidx.compose.runtime.*
import app.bloomey.web.components.layouts.AdminPageLayout
import app.bloomey.web.components.sections.PageActionsBar
import app.bloomey.web.components.widgets.*
import app.bloomey.web.core.data.UiState
import app.bloomey.web.modules.feedback.FeedbackContract
import app.bloomey.web.modules.feedback.FeedbackViewModel
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

@Page
@Composable
fun FeedbacksPage() {
    val scope = rememberCoroutineScope()
    val viewModel = remember { FeedbackViewModel(scope) }
    val uiState by viewModel.observeStates().collectAsState()

    val route = rememberPageContext().route
    val searchQuery = remember { mutableStateOf(route.queryParams["q"] ?: "") }
    val getPage = { page: Int ->
        viewModel.trySend(
            FeedbackContract.Inputs.GetPage(
                page = page,
                size = 20,
                query = searchQuery.value
            )
        )
    }

    LaunchedEffect(Unit) {
        getPage(1)
    }

    val nextPage = uiState.itemsState
    AdminPageLayout(pageTitle = "Feedbacks") {


        when (nextPage) {
            is UiState.Error -> SiteErrorView(
                Modifier.minHeight(80.vh),
                text = nextPage.errorMessage
            ) {
                getPage(uiState.page)
            }

            UiState.Initial -> {}
            UiState.Loading -> LoadingView(Modifier.minHeight(80.vh))
            is UiState.Success -> {
                PageActionsBar(searchValue = searchQuery) {
                    getPage(1)
                }
                ShowingItems(modifier = Modifier.margin(bottom = 24.px), nextPage.data.totalItems)
                SimpleGrid(
                    numColumns = numColumns(
                        base = 1, sm = 2, md = 3, lg = 4, xl = 5
                    ),
                    modifier = Modifier
                        .maxWidth(100.percent)
                        .fillMaxWidth()
                        .rowGap(18.px)
                        .columnGap(24.px)
                        .margin(bottom = 39.px)
                ) {
                    nextPage.data.items.forEach {
                        FeedbackItem(modifier = Modifier.weight(1), feedback = it)
                    }
                }

                PaginationController(
                    modifier = Modifier.alignSelf(AlignSelf.FlexEnd),
                    pageCount = nextPage.getData.totalPages,
                    currentPage = uiState.page,
                    windowSize = 5
                ) {
                    getPage(it)
                }
            }
        }

        Height(30.px)
    }
}